<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Raport general"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label="Numar" size="mini">
                <el-input v-model="Filters.Numar" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Centru productie' size="mini">
                  <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable >
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id" :label='item.Nume' :value='item.Id'/>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Serviciu programator'  size="mini">
                  <el-select class='full-width' v-model='Filters.IdServiciuProgramator' filterable >
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.servicii_programator' :key="'serviciu_programator' + item.Id" :label='item.Nume' :value='item.Id'/>
                  </el-select>
              </el-form-item>
            </el-col>       
            <el-col  class="input-element">
              <el-form-item label='Mecanic' size="mini">
                <div class="input-group full-width"> 
                  <el-select class='full-width' v-model='Filters.IdMecanic' filterable >
                      <el-option label='Toti' value='-1'></el-option>
                      <el-option-group key="Activi">
                        <el-option v-for='item in Info.mecanici' :key="'mecanici' + item.Id" :label='item.Nume' :value='item.Id' />
                      </el-option-group>
                      <el-option-group v-if="Filters.ArataMecaniciInactivi==1" key="Inactivi" label="Inactivi">
                        <el-option v-for='item in Info.mecanici_inactivi' :key="'mecanici_inactivi' + item.Id" :label='item.Nume' :value='item.Id'/>
                      </el-option-group>
                      <el-option-group v-if="Filters.ArataMecaniciStersi==1" key="Stersi" label="Stersi">
                        <el-option v-for='item in Info.mecanici_stersi' :key="'mecanici_stersi' + item.Id" :label='item.Nume' :value='item.Id'/>
                      </el-option-group>
                  </el-select>
                  <div class="input-group-append">
                    <el-checkbox size="mini"
                        v-model="Filters.ArataMecaniciInactivi"
                        true-label="1"
                        false-label="0"
                        @change="schimbaListaMecanici()"
                      >
                        <small>Arata inactivi</small>
                      </el-checkbox>
                      <el-checkbox size="mini"
                        v-model="Filters.ArataMecaniciStersi"
                        true-label="1"
                        false-label="0"
                        @change="schimbaListaMecaniciStersi()"
                      >
                        <small>Arata stersi</small>
                      </el-checkbox>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Status' size="mini">
                  <el-select class='full-width' v-model='Filters.Status' filterable >
                      <el-option label='Aprobate' value='Aprobat'></el-option>
                      <!-- <el-option label='Draft' value='Draft'></el-option>  --> <!-- daca punen draft trebuie scoasa conditia din sql sa aiba DataTerminareLucru -->
                      <el-option label='In validare' value='In_validare'></el-option>
                      <el-option label='Facturate' value='Facturat'></el-option>
                      <el-option label='Toate' value='-1'></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col class="input-element">
               <el-form-item label='Interval' size="mini">
                 <br>
                  <el-date-picker      
                      v-model="Filters.Data"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="Data inceput"
                      end-placeholder="Data sfarsit"
                      :picker-options="datePickerOptions"
                      format="dd/MM/yyyy" value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col class="input-element">
              <el-form-item label='Hotel' size="mini">
                  <el-select class='full-width' v-model='Filters.Hotel' filterable >
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option label='Da' value='1'></el-option>
                      <el-option label='Nu' value='0'></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()"
                size="mini">
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()" size="mini">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results" v-loading="loading">
      <el-table-column type="expand" align="center">
        <template #default="props">
          <el-table style="width: 96%; margin-left: 4%;" :row-class-name="'tabel2'" :show-header="true" el-table :data="props.row.mecanici">
            <el-table-column type="expand">
              <template #default="props">
                <el-table style="width: 97%; margin-left: 3%;" :show-header="true" border :data="props.row.devize">
                  <el-table-column  prop="Id" label="#"></el-table-column>
                  <el-table-column label="Numar" prop="Numar"></el-table-column>
                  <el-table-column label="Status">
                    <template slot-scope="scope">
                      {{ scope.row.Status }}
                    </template>
                  </el-table-column>   
                  <el-table-column label="Hotel" align="right">
                    <template slot-scope="scope">
                      <span v-if="scope.row.Hotel == 1">Da</span>
                      <span v-else>Nu</span>
                    </template>
                  </el-table-column> 
                  <!-- <el-table-column label="Data preluare">
                    <template slot-scope="scope">
                      {{ format_zi(scope.row.DataPreluareInLucru) }} {{ format_ora(scope.row.DataPreluareInLucru) }} 
                    </template>
                  </el-table-column>  -->
                  <!-- <el-table-column label="Data terminare">
                    <template slot-scope="scope">
                      {{ format_zi(scope.row.DataTerminareLucru) }} {{ format_ora(scope.row.DataTerminareLucru) }} 
                    </template>
                  </el-table-column>  -->
                  <el-table-column prop="Durata" align="right" label="Durata (minute)"></el-table-column>
                  <!-- <el-table-column prop="NumeClient" label="Client"></el-table-column> -->
                  <el-table-column prop="ValoareDeviz" label="Valoare" align="right"></el-table-column>
                  <el-table-column  fixed="right"  align="right" label="Descarca deviz">
                    <template slot-scope="scope">
                      <!-- <el-tooltip content="Preview">
                        <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)"/>
                      </el-tooltip>  -->
                      <el-tooltip content="Print deviz">
                        <el-button type="info" size="mini" icon="el-icon-printer" circle @click="print_deviz(scope.row.Id)"/>
                      </el-tooltip>
                      <!-- <el-tooltip content="Print inspectie">
                        <el-button type="warning" size="mini" icon="el-icon-printer" circle @click="print_inspectie(scope.row.Id)" />
                      </el-tooltip>           -->
                    </template>
                  </el-table-column>

                </el-table>
              </template>
            </el-table-column>
            <el-table-column  prop="NumeMecanic" label="Mecanic"/>
            <el-table-column  prop="NumeCentru" label="Centru productie"/>
            <el-table-column  prop="NumeServiciu" label="Serviciu"/>
            <el-table-column  prop="NumarDevizeMecanic" label="Numar de devize" align="right"/>
            <el-table-column  prop="TotalDurataDevizeMecanic" label="Durata totala / zi" align="right"></el-table-column>
            <el-table-column  prop="DurataMedieDevizeMecanic" label="Durata medie" align="right"></el-table-column>
            <el-table-column  prop="ValoareDevizeMecanic" label="Valoare" align="right"></el-table-column>
          </el-table>

        </template>
      </el-table-column>
      <el-table-column prop="zi" label="Zi"></el-table-column>
      <el-table-column prop="NumarDevizeZi" label="Numar de devize" align="right"></el-table-column>
      <el-table-column prop="TotalDurataDevizeZi" label="Durata totala / zi" align="right"></el-table-column>
      <el-table-column prop="DurataMedieDevizeZi" label="Durata medie" align="right"></el-table-column>
      <el-table-column prop="ValoareDevizeZi" label="Valoare" align="right"></el-table-column>
      <!-- <el-table-column prop="TotalDevizeRaport" label="TotalDevizeRaport  de pus in in subsol" align="right"></el-table-column>
      <el-table-column prop="DurataMedieDevizeRaport" label="DurataMedieDevizeRaport de pus in in subsol" align="right"></el-table-column> -->

    </el-table>
    <div class="total">
      <p v-if='TotalDevizeRaport'>Total devize raport: <strong>{{TotalDevizeRaport}} </strong></p>
      <p v-if="DurataMedieDevizeRaport">Durata medie devize raport: <strong>{{DurataMedieDevizeRaport}}</strong></p>

    </div>


    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
    <Previewdeviz   ref="preview_deviz" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import moment from 'moment';

export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    Previewdeviz,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      device: "",
      showDialogDatePersonale: false,
      TotalDevizeRaport: "",
      DurataMedieDevizeRaport: "",
      Results: [],
      DateList: [],
      base_url: "",
      loading:false,
      Info: {
        clienti: [],
      },
      Filters: {
        Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD 23:59:59')],
        Numar: "",
        DataDeschiderii: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        IdMecanic: "-1",
        Status: "-1",
        Hotel: "-1",
        ArataMecaniciStersi:'0',
        ArataMecaniciInactivi:'0',
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async preview(id) {
      this.$refs.preview_deviz.show(id)
    },   

    format_zi(data){                               
      return moment(data).format('YYYY-MM-DD')
    },
    
    schimbaListaMecanici(){
      if(this.Filters.ArataMecaniciInactivi == 0){
        let MecaniculSelectat = this.Info.mecanici_inactivi.filter((value) => value.Id == this.Filters.IdMecanic);
        if(MecaniculSelectat.length > 0)
          if(MecaniculSelectat[0].Dezactivat == 1)   this.Filters.IdMecanic = "-1";
      }
    },    
    schimbaListaMecaniciStersi() {
        if (this.Filters.ArataMecaniciStersi == 0) {
          let mecanicSelectat = this.Info.mecanici_stersi.filter((value) => value.Id == this.Filters.IdMecanic);
          if (mecanicSelectat.length > 0) {
            if (mecanicSelectat[0].Sters == 1) {
              this.Filters.IdMecanic = "-1";
            }
          }
        }
      },
    
    calculeaza_durata(start, stop){             
      return moment(stop).diff(start, 'minutes');                  
    },    
    
    format_ora(data){                               
      return moment(data).format('HH:mm:ss')
    },
    
    print_inspectie(id_deviz){                               
      // window.open("/#/inspectie_finala/" + id_deviz, '_blank');
      let isDev = '';
      if (this.base_url == 'https://service.anvelopeinstoc.ro/dev/api/index.php') {
          isDev = '/dev'
      }
      window.open( isDev + "/#/inspectie_finala/" + id_deviz, '_blank');
    },
    
    print_deviz(id_deviz){                               
      // window.open("/#/deviz_produse_pdf/" + id_deviz, '_blank');
      let isDev = '';
      if (this.base_url == 'https://service.anvelopeinstoc.ro/dev/api/index.php') {
          isDev = '/dev'
      }
      window.open( isDev + "/#/deviz_produse_pdf/" + id_deviz, '_blank');
    },
    
    async get_info() {
      var response = await this.post("receptie/devize/get_info_raport_mecanici");
      // this.Info.clienti  = response.clienti;
      this.Info.mecanici = response.mecanici;
      this.Info.mecanici_inactivi = response.mecanici_inactivi;
      this.Info.mecanici_stersi = response.mecanici_stersi;
      this.Info.centre_productie = response.centre_productie;
      this.Info.servicii_programator = response.servicii_programator;
      this.refresh_info();
    },

    async refresh_info() {
      try {
      this.loading = true;
        var response = await this.post("receptie/devize/get_raport_mecanici_grupat_vechi", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      // console.log(this.Results)

      this.TotalDevizeRaport = 0;
      if (this.Results[0] !== undefined)
        this.TotalDevizeRaport = this.Results[0].TotalDevizeRaport;

      this.DurataMedieDevizeRaport = 0;
      if (this.Results[0] !== undefined)
        this.DurataMedieDevizeRaport = this.Results[0].DurataMedieDevizeRaport;

      // console.log(this.Results)
      this.PaginationInfo = response.PaginationInfo;

      } catch (error) {
        console.error(error)
      }finally{
        this.loading = false;
      }
      
      
    },
    reset() {
      this.Filters = {
        Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD hh:mm')],
        Numar: "",
        DataDeschiderii: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        IdMecanic: "-1",
        Status: "-1",
        Hotel: "-1",
        ArataMecaniciStersi:'0',
        ArataMecaniciInactivi:'0',
      };
      this.refresh_info();
    },

  },

  created() {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      this.device = "phone"
    } else this.device = "computer"
  },
  mounted() {
    this.select_menu_item("raport_mecanici");

    // if (!this.$has_right("Management")) {
    //   this.$router.push("/no-rights");
    //   return;
    // }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.input-group {
  display: flex;
  align-items: flex-start;
  // justify-content: space-between;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}



.total {
  width: 100%;
  background-color: white;
  padding: 14px 10px;
  text-align: end;
  font-size: 18px;
}


.input-element {
  width: 23%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
    
  }

  .phone-btn {
    padding-left: 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .input-group {
    margin: 10px;
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 300px;
  }

  .el-picker-panel__body {
    display: flex;
    flex-direction: column;
  }
}
</style>
